module.exports = __webpack_public_path__ + "static/media/zt_statisticsIndexTitle.aba4db9a.png";